import { Injectable } from '@angular/core';
import { ClientType } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientDropServiceService {

  isShowClientType : ClientType;
  showClientType : BehaviorSubject<ClientType> = new BehaviorSubject<ClientType>(null);


  constructor() {
    this.showClientType.subscribe(res => {
      this.isShowClientType;
    })
   }

  //  showClientTypes(){

  //   return this.isShowClientType;
  //  }

  //  setClientType(){
  //   this.showClientType.next(this.isShowClientType);
  //  }
}
